import React from 'react'

export function BubbleText(props) {

  return (
    <span
      className='bubble-text'
    >
      {props.children}
    </span>
  )
}
